import { render, staticRenderFns } from "./NotForJob.vue?vue&type=template&id=8e4e2a4e&scoped=true&"
import script from "./NotForJob.vue?vue&type=script&lang=js&"
export * from "./NotForJob.vue?vue&type=script&lang=js&"
import style0 from "./NotForJob.vue?vue&type=style&index=0&id=8e4e2a4e&prod&lang=less&scoped=true&"
import style1 from "./NotForJob.vue?vue&type=style&index=1&id=8e4e2a4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4e2a4e",
  null
  
)

export default component.exports